// simplified version of lodash/toString as we don't need to support symbols

const INFINITY = 1 / 0;

export default function toString(value) {
  if (value == null) {
    return '';
  }

  if (typeof value === 'string') {
    return value;
  }

  if (Array.isArray(value)) {
    return `${value.map(toString)}`;
  }

  const result = `${value}`;

  // eslint-disable-next-line eqeqeq
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
